import MobileFooter from '../../components/Mobile/MobileFooter';

const MobileProfile = () => {
    return (
        <div>
            <h1>MobileProfile</h1>
          <MobileFooter />
        </div>
    );
}

export default MobileProfile;